import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { CheckNameExistsRequest, ManufacturerClient } from 'src/app/shared/api-connector/sso-connector';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AutocompleteCacheService } from 'src/app/shared/services/autocomplete-cache.service';

@Component({
  selector: 'app-add-manufacturer-dialog',
  templateUrl: './add-manufacturer-dialog.component.html',
  styleUrls: ['./add-manufacturer-dialog.component.scss']
})
export class AddManufacturerDialogComponent implements OnInit {
  nameCtrl = new FormControl('', {
    validators: [Validators.required],
    updateOn: 'change',
    asyncValidators: [this.validateManufacturerNameNotTaken.bind(this)]
  });
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<AddManufacturerDialogComponent>,
    private alertService: AlertService,
    private manufacturerClient: ManufacturerClient,
    private autocompleteCache: AutocompleteCacheService
  ) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }

  validateManufacturerNameNotTaken(control: FormControl): any {
    if (control.value) {
      return this.manufacturerClient.checkManufacturerNameExists(new CheckNameExistsRequest({
        name: this.nameCtrl.value
      })).pipe(
        map(res => {
          return res ? { nameTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  onSubmit() {
    if (this.nameCtrl.valid) {
      this.spinner.show();
      this.manufacturerClient.create(this.nameCtrl.value)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe(x => {
          this.autocompleteCache.clearType('manufacturer_');
          this.alertService.success('Thêm mới vị trí thành công', 'Thêm vị trí');
          this.dialogRef.close(this.nameCtrl.value);
        });
    }
  }
}
